<template>
  <loading-data-page-container :loading="loading"
                               :loading-error="loadingError"
                               :loading-error-message="loadingErrorMsg">

    <v-container v-if="!loading && !loadingError" class="pa-0" fluid>

      <privat-confirm v-if="confirm"
                      aenderung
                      state-path="editContract" />

      <div v-else
           class="aenderungsantrag-page">

        <!-- read mode: view of all sections -->
        <template v-if="!edit">

          <vertrags-header :vertragsnummer="vertrag.LangeVertragsnummer"
                           :kunden-name="vertrag.Vorname + ' ' + vertrag.Name"
                           class="vertragsHeader"
                           page-name="Vertragsänderung" />

          <div style="position: relative; width: 344px;">
            <date-field v-model="gueltigAb"
                        v-validate="{ required: true, date_format: ['DD.MM.YYYY'], date_between: [minGueltigAb, maxGueltigAb, true] }"
                        :error-messages="errors.collect('gueltigAb')"
                        data-vv-as="Gültigkeit der Änderung"
                        required
                        hint="tt.mm.jjjj"
                        name="gueltigAb"
                        label="Änderung gültig ab"
                        @input="validateGueltigAb" />
          </div>

          <details-section :items="versicherungsnehmerItems"
                           title="Versicherungsnehmer"
                           divider
                           editable
                           @edit="setEdit(pageNames.versicherungsnehmer)" />

          <details-section :items="mitversichertePersonItems"
                           title="Mitversicherte Person"
                           divider
                           editable
                           @edit="setEdit(pageNames.mitversichertePerson)" />

          <details-section :items="zahlungsartItems"
                           title="Zahlungsart"
                           divider
                           editable
                           @edit="setEdit(pageNames.zahlungsart)" />

          <details-section :items="versicherungsumfangItems"
                           divider
                           editable
                           hinttext="Vorbelegung der Daten für den Versicherungsumfang wird noch ergänzt"
                           title="Versicherungsumfang"
                           @edit="editUmfang" />

          <div class="semanticsection-title2">
            <span class="primary--text ueber">Zusätzliche Mitteilungen</span>
          </div>

          <div class="textarea-box">
            <v-text-field v-model="anmerkungen"
                          :counter="200"
                          maxlength="200"
                          clearable
                          class="mitteilungen ma-0" />
          </div>

          <div class="semanticsection-title2">
            <span class="primary--text ueber">Zusätzliche Dokumente</span>
          </div>
          <div>
            <file-upload-multi state-path="editContract"
                               class="pa-0" />
          </div>

          <div class="buttons">
            <v-btn class="standard-button"
                   @click="goBack">Abbrechen
            </v-btn>
            <v-btn :disabled="artAenderung.length === 0"
                   class="standard-button"
                   color="primary white--text"
                   @click="submitChanges">Änderung einreichen
            </v-btn>
          </div>

        </template>

        <div v-else
             class="edit">

          <!-- edit mode:  edit view of one section -->
          <template v-if="edit===pageNames.versicherungsnehmer">
            <edit-section title="Versicherungsnehmer"
                          @cancel="setEdit(null)"
                          @update-profile="sectionChanged"
                          @error="showSnackbar('Bitte überprüfen Sie Ihre Eingaben.')">
              <person state-path="editContract.vn"
                      form-ref="editForm" />
            </edit-section>
          </template>

          <!-- edit mode:  edit view of one section -->
          <template v-else-if="edit===pageNames.mitversichertePerson">
            <edit-section title="Mitversicherte Person"
                          @cancel="setEdit(null)"
                          @update-profile="sectionChanged"
                          @error="showSnackbar('Bitte überprüfen Sie Ihre Eingaben.')">
              <person state-path="editContract.mvp"
                      form-ref="editForm" />
            </edit-section>
          </template>

          <!-- edit mode:  edit view of one section -->
          <template v-else-if="edit===pageNames.zahlungsart">
            <edit-section title="Zahlungsart"
                          @cancel="setEdit(null)"
                          @update-profile="sectionChanged"
                          @error="showSnackbar('Bitte überprüfen Sie Ihre Eingaben.')">
              <zahlungsart state-path="editContract"
                           form-ref="editForm" />
            </edit-section>
          </template>

        </div>
      </div>

    </v-container>

    <!-- error message for editing data -->
    <v-snackbar v-model="snackbar"
                :timeout="4000"
                color="error"
                bottom
                multi-line>
        <span class="snackbar-message text-center">
          <v-icon color="white">warning</v-icon>{{ message }}</span>
    </v-snackbar>

    <!-- dialog for submitting application -->
    <v-dialog
      v-model="angebotDialog.show"
      :width="angebotDialog.width"
      :persistent="!angebotDialog.isSuccess && !angebotDialog.isError"
      content-class="angebot-dialog">
      <angebot-dialog :title="angebotDialog.title"
                      :success="angebotDialog.isSuccess"
                      :error="angebotDialog.isError"
                      @close="angebotDialog.show=false" />
    </v-dialog>

  </loading-data-page-container>
</template>
<script>
import {mapGetters} from "vuex";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import DetailsSection from "@/components/userProfile/DetailsSection";
import httpService from '@/helper/httpService';
import EditSection from "@/components/userProfile/EditSection";
import Person from "@/components/privatkundenrechner/Person.vue";
import Zahlungsart from "@/components/privatkundenrechner/Zahlungsart.vue";
import FileUploadMulti from "@/components/FileUploadMulti";
import VertragsHeader from '@/components/kundenverwaltung/VertragsHeader';
import AngebotDialog from "@/components/privatkundenrechner/AngebotDialog";
import PrivatConfirm from "@/components/privatkundenrechner/PrivatConfirm";
import dummyData from "@/store/dummyData/bestandDummyData";
import {AENDERUNG_PAGE_NAMES} from "@/components/kundenverwaltung/valueLists";
import DateField from "@/components/DateField";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import {CONNECTION_ERROR_MESSAGE} from "@/helper/httpService";
import {getDateString} from "@/helper/dateService";

function anredeValueToLabel(anredeValue) {
  const anredeValueToLabelMap = {
    F: "Frau",
    Frau: "Frau",
    Herr: "Herr",
    H: "Herr",
    kA: "keine Angabe"
  };
  const anredeLabelFromValue =  anredeValueToLabelMap[anredeValue];
  return anredeLabelFromValue ? anredeLabelFromValue : "";
}

export default {
  name: "AenderungsantragPage",
  components: {
    LoadingDataPageContainer,
    DetailsSection,
    EditSection,
    Person,
    Zahlungsart,
    FileUploadMulti,
    VertragsHeader,
    PrivatConfirm,
    AngebotDialog,
    DateField
  },
  mixins: [twowayBinding, KeyTranslator, ValidationMixin],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      vertrag: this.$route.params['vertrag'],
      snackbar: false,
      message: '',
      edit: null,
      pageNames: AENDERUNG_PAGE_NAMES,
      angebotDialog: {
        show: false,
        title: '',
        width: 500,
        isError: false,
        isSuccess: false,
        pdfUrl: ''
      },
      confirm: false,
      tmpStoreState: {}
    };
  },
  computed: {
    ...mapGetters([
      "getContractLength",
      "productKey",
      "productLineText",
      "getProductText",
      "getSb",
      "getSsrSb"
    ]),
    ...mapTwoWay(
      [
        "artAenderung",
        "ssrselected",
        "ssrsb",
        "cyberselected",
        "cybersb",
        "zwselected",
        "sb",
        "zahlweise",
        "contractlength",
        "civilServant",
        "family",
        "productLine",
        "sus",
        "vermselected",
        "vermvalid",
        "vermwohnungen",
        "rechnungszahler",
        "categories",
        "trafficType",
        "anmerkungen",
        "gueltigAb",
        "gueltigAbVergangenheit"
      ]),
    minGueltigAb() {
      return getDateString(new Date(new Date().setDate(new Date().getDate() + 1)));
    },
    maxGueltigAb() {
      const now = new Date();
      const nowPlusOneYear = new Date(now.setFullYear(now.getFullYear() + 1));
      return getDateString(nowPlusOneYear);
    },
    currentPraemien() {
      return this.$store.getters.currentPraemien(this.statePath);
    },
    totalVermWohnungen() {
      return this.currentPraemien.vermieter.reduce((vermieterPraemie, wohnung) => vermieterPraemie + wohnung.praemie, 0.0);
    },
    rawPraemien() {
      return this.$store.getters.rawPraemien;
    },
    versicherungsnehmerItems: function () {
      if (this.showSection(this.pageNames.versicherungsnehmer)) {
        return [
          {
            label: "Anrede",
            value: anredeValueToLabel(this.$store.state.editContract.vn.anrede)
          },
          { label: "Titel", value: this.$store.state.editContract.vn.titel },
          {
            label: "Name",
            value: `${this.$store.state.editContract.vn.firstname} ${this.$store.state.editContract.vn.lastname}`
          },
          {
            label: "Straße",
            value: `${this.$store.state.editContract.vn.strasse} ${this.$store.state.editContract.vn.hausnummer}`
          },
          { label: "Adresszusatz", value: this.$store.state.editContract.vn.adresszusatz },
          { label: "Ort", value: `${this.$store.state.editContract.vn.plz} ${this.$store.state.editContract.vn.ort}` },
          { label: "Geburtsdatum", value: this.$store.state.editContract.vn.geburt },
          { label: "Beruf", value: this.$store.state.editContract.vn.beruf },
          { label: "E-Mail", value: this.$store.state.editContract.vn.email },
          { label: "Festnetznummer", value: this.$store.state.editContract.vn.telefon },
          { label: "Mobilnummer", value: this.$store.state.editContract.vn.mobil },
          { label: "Staatsangehörigkeit Land", value: this.$store.state.editContract.vn.staat }
        ];
      } else {
        return [];
      }
    },
    mitversichertePersonItems: function () {
      if (this.showSection(this.pageNames.mitversichertePerson)) {
        return [
          {
            label: "Anrede",
            value: anredeValueToLabel(this.$store.state.editContract.mvp.anrede)
          },
          { label: "Titel", value: this.$store.state.editContract.mvp.titel },
          {
            label: "Name",
            value: `${this.$store.state.editContract.mvp.firstname} ${this.$store.state.editContract.mvp.lastname}`
          },
          { label: "Geburtsdatum", value: this.$store.state.editContract.mvp.geburt },
          { label: "Beruf", value: this.$store.state.editContract.mvp.beruf }
        ];
      } else {
        return [];
      }
    },
    zahlungsartItems: function () {
      let zahlungstabelle = [];
      // wenn zahlungsart geändert wurde
      if (this.showSection(this.pageNames.zahlungsart)) {
        zahlungstabelle.push({
          label: "Zahlungsart",
          value: this.$store.state.editContract.rechnungszahler === "J" ? "Rechnung" : this.$store.state.editContract.rechnungszahler === "N" ? "Bankeinzug" : this.$store.state.editContract.rechnungszahler === "M" ? "Maklerinkasso" : ""
        });

        //wenn Lastschriftzahler dann zusätzlich Bankdaten ausgeben
        if (this.$store.state.editContract.rechnungszahler === "N") {
          zahlungstabelle.push({ label: "IBAN", value: this.$store.state.editContract.iban });

          //wenn ausländische IBAN dann BIC ausgeben
          if (this.$helpers.isIbanAusland(this.$store.state.editContract.iban)) {
            zahlungstabelle.push({ label: "BIC", value: this.$store.state.editContract.bic });
          }
          zahlungstabelle.push({
            label: "Kontoinhaber",
            value: this.$store.state.editContract.inhabertyp === "VN" ? "Versicherungsnehmer" : this.$store.state.editContract.inhabertyp === "AK" ? "abweichender Kontoinhaber" : ""
          });

          //wenn abwechender Kontoinhaber dann Kontoinhaberdaten ausgeben
          if (this.$store.state.editContract.inhabertyp === "AK") {
            zahlungstabelle.push({
              label: "Anrede",
              value: anredeValueToLabel(this.$store.state.editContract.kontoinhaber.anrede)
            });
            zahlungstabelle.push({ label: "Titel", value: this.$store.state.editContract.kontoinhaber.titel });
            zahlungstabelle.push({
              label: "Name",
              value: `${this.$store.state.editContract.kontoinhaber.firstname} ${this.$store.state.editContract.kontoinhaber.lastname}`
            });
            zahlungstabelle.push({
              label: "Adresszusatz",
              value: this.$store.state.editContract.kontoinhaber.adresszusatz
            });
            zahlungstabelle.push({
              label: "Straße",
              value: `${this.$store.state.editContract.kontoinhaber.strasse} ${this.$store.state.editContract.kontoinhaber.hausnummer}`
            });
            zahlungstabelle.push({
              label: "Ort",
              value: `${this.$store.state.editContract.kontoinhaber.plz} ${this.$store.state.editContract.kontoinhaber.ort}`
            });
          }
        }

      }
      return zahlungstabelle;
    },
    versicherungsumfangItems: function () {
      if (this.showSection(this.pageNames.umfang)) {
        let items = [
          { label: 'im öffentlichen Dienst tätig', value: this.civilServant ? 'Ja' : 'Nein' },
          {
            label: 'Familienstand',
            value: this.family === 'MPH' ? 'Familie' : this.family === 'EPH' ? 'Single/Alleinerziehend mit Kind' : 'Familienstand n.a.'
          },
          {
            label: 'Laufzeit',
            value: `${this.getContractLength('editContract')} Jahr${this.getContractLength('editContract') === '3' ? 'e' : ''}`
          }
        ];
        if (!this.sus) {
          items = items.concat([
            { label: 'Produkt', value: `${this.productLineText(this.productLine)}` },
            { label: 'Versicherungsumfang', value: this.getProductText(this.statePath) }
          ]);
        } else {
          items.push(
            { label: 'Produkt', value: `${this.productLineText(this.productLine)} Schnell & Sicher` }
          );
        }
        items.push(
          {
            label: this.praemienName(this.zahlweise),
            value: this.$helpers.toGermanFloatString(this.currentPraemien.main),
            suffix: '€'
          }
        );
        if (this.cyberselected) {
          items.push(
            {
              label: 'Cyber-Rechtsschutz',
              value: this.$helpers.toGermanFloatString(this.currentPraemien.cyber),
              suffix: '€'
            }
          );
        }
        if (this.ssrselected) {
          items.push(
            {
              label: 'Spezial-Straf-Rechtsschutz',
              value: this.$helpers.toGermanFloatString(this.currentPraemien.ssr),
              suffix: '€'
            }
          );
        }
        if (this.zwselected) {
          items.push(
            {
              label: 'zusätzliche Zweit-/Ferienwohnung',
              value: this.$helpers.toGermanFloatString(this.currentPraemien.zweitwohnung),
              suffix: '€'
            }
          );
        }
        if (this.vermselected) {
          items.push(
            {
              label: `vermietete Wohneinheit${this.vermwohnungen.length > 1 ? 'en' : ''} (${this.vermwohnungen.length})`,
              value: this.$helpers.toGermanFloatString(this.totalVermWohnungen),
              suffix: '€'
            }
          );
        }
        items.push(
          {
            label: `${this.praemienName(this.zahlweise)} gesamt`,
            value: this.$helpers.toGermanFloatString(this.currentPraemien.total),
            suffix: '€'
          }
        );
        return items;
      } else {
        return [];
      }
    }
  },
  created() {
    if (this.$store.state.env.environment === 'development') {
      this.vertrag = dummyData[0];
      this.$store.commit("setVertragForAenderung", {
        vertragsnummer: this.vertrag.Vertragsnummer,
        firstname: this.vertrag.Vorname,
        lastname: this.vertrag.Name,
        altvertrag: this.vertrag
      });
      this.loading = false;
    } else {
      // Get the contract data from the backend
      httpService.getVertrag(this.$route.params['vertragsnummer'])
        .then(vertrag => {
          this.vertrag = vertrag;
          this.$store.commit("setVertragForAenderung", {
            vertragsnummer: this.vertrag.Vertragsnummer,
            firstname: this.vertrag.Vorname,
            lastname: this.vertrag.Name,
            altvertrag: this.vertrag
          });
          this.loading = false;
        })
        .catch(err => {
          console.log(`GET CONTRACTS failed with ${err.status}: ${err.message}`);
          this.loadingErrorMsg = err.status < 500 ? 'Kein Vertrag gefunden' : CONNECTION_ERROR_MESSAGE;
          this.loadingError = true;
          this.loading = false;
        });
    }
  },
  beforeDestroy() {
    if (this.confirm) {
      this.$store.dispatch('resetAenderungsData');
    }
  },
  methods: {
    validateGueltigAb() {
      this.$validator.validate('gueltigAb');
    },
    setEdit: function (section, updated) {
      //if edit-section, then backup the store
      if (section !== null) {
        this.tmpStoreState = JSON.parse(JSON.stringify(this.$store.state.editContract));
      } else {
        //if the user click "cancel", restore the store
        if (updated !== true) this.$store.commit('restoreAenderungState', this.tmpStoreState);
      }
      this.edit = section;
      window.scrollTo(0, 0);
    },
    editUmfang: function () {
      this.$store.commit("resetSteps", { page: 'aenderung' });
      this.$router.push({
        name: 'AenderungUmfangPage', params: {
          nummer: this.vertrag.Vertragsnummer, art: 'vertrag',
          data: this.vertrag
        }
      });
    },
    showSection(section) {
      return this.artAenderung.includes(section);
    },
    goBack: function () {
      window.history.back();
    },
    submitChanges: function () {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            this.showSnackbar('Bitte überprüfen Sie Ihre Eingaben.');
          } else {
            this.sendApplication();
          }
        });
    },
    sendApplication() {
      this.angebotDialog.title = 'Antrag';
      this.angebotDialog.isSuccess = false;
      this.angebotDialog.pdfUrl = '';
      this.angebotDialog.isError = false;
      this.angebotDialog.width = 500;
      this.angebotDialog.show = true;

      this.$store.dispatch("submitFormular", { statePath: "editContract", formularType: "Antrag" })
        .then(() => {
          this.angebotDialog.show = false;
          this.confirm = true;
        })
        .catch((err) => {
          console.log(`POST APPLICATION failed with ${err.status}: ${err.message}`);
          this.angebotDialog.isError = true;
        });
    },
    sectionChanged: function () {
      this.$store.commit('markAsChanged', { section: this.edit });
      this.setEdit(null, true);
      return "";
    },
    showSnackbar: function (msg) {
      this.message = msg;
      this.snackbar = true;
    }
  }
};
</script>

<style>
.aenderungsantrag-page .edit {
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
}

.aenderungsantrag-page .buttons {
  margin-top: 40px;
}

.aenderungsantrag-page .buttons .standard-button {
  margin: 0 40px 0 0;
}

.aenderungsantrag-page .details-table td:first-child {
  white-space: nowrap;
}

.mitteilungen {
  max-width: 100% !important;
}

.aenderungsantrag-page .edit .row.space-between > div[class*=col-]:nth-child(even) {
  display: flex;
  justify-content: flex-end;
  padding-left: 24px !important;
}

.aenderungsantrag-page .edit .row.space-between > div[class*=col-]:nth-child(odd) {
  padding-right: 24px !important;
}

.aenderungsantrag-page .vertragsHeader {
  z-index: 1;
}

.aenderungsantrag-page .custom-label-inputgroup {
  display: flex;
  align-items: flex-start;
}

.aenderungsantrag-page .custom-label-inputgroup .mylabel {
  margin-left: 8px;
  width: 100%;
  font-size: 16px;
}

.aenderungsantrag-page .custom-label-inputgroup .error--text {
  font-size: 12px;
  min-height: 1.5em;
}
</style>
